import store from '@/store';

function routerBeforeEnterGiftCardGifting(to, from, next) {
  const giftingEnabled = store.getters['giftCards/giftCardGiftingEnabled'];

  const menuReroute = {
    name: 'order',
    params: {
      merchantId: to.params.merchantId
    }
  };

  return giftingEnabled ? next() : next(menuReroute);
}

export default routerBeforeEnterGiftCardGifting;
